
//const apiurl = "http://apievcustomer.de/pp/api/backend/";
const apiurl = "https://api.evolvejobs.de/pp/api/backend/";

export default apiurl;